import React, { useState } from 'react';
import { Dialog, ElevatedButton, TextButton } from '@producer/ui-kit';

import { catchError } from '../../../core/catch-error';

import type { Member } from '../../../app/entities';

import styles from './remove-member.modal.module.scss';
type ModalProps = {
  member: Member;
  onCancel: () => void;
};

export const RemoveMemberModal: React.FC<ModalProps> = ({ onCancel, member }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    if (isLoading) return;

    setIsLoading(true);

    try {
      await member.delete();
    } catch (error) {
      catchError(error);
    } finally {
      setIsLoading(false);
      onCancel();
    }
  };

  return (
    <Dialog
      title={`Are you sure you want to remove "${member.fullName}"`}
      onClose={onCancel}
      actions={[
        <TextButton key="cancel" text="Cancel" onClick={onCancel} />,
        <ElevatedButton
          variant="danger"
          text="Yes, remove access"
          type="submit"
          onClick={handleSubmit}
          key="delete-submit-button"
          isLoading={isLoading}
          autoFocus
        />,
      ]}
    >
      <span className={styles['information-text']}>
        They won&apos;t be able to access your creative space anymore.
      </span>
    </Dialog>
  );
};
